export default "__VITE_ASSET__CJRhk8la__"